// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"ad6cd484","453":"42e83c59","591":"b56c508e","680":"742a6d18","900":"8cf64654"}[chunkId] + ".chunk.js";
};